import React from "react";
import { useParams, Link } from "react-router-dom";
import { CheckCircle } from "lucide-react";

const OrderConfirmation = () => {
  const { id } = useParams();
  return (
    <main className="py-24 min-h-[60vh]" data-testid="order-confirmation">
      <div className="max-w-xl mx-auto px-6 text-center">
        <CheckCircle className="w-16 h-16 mx-auto text-[var(--gold-deep)] mb-6" strokeWidth={1} />
        <h1 className="font-display text-4xl lg:text-5xl mb-4">Thank You</h1>
        <p className="text-[var(--noir-soft)] mb-2">Your order request has been prepared in your email app.</p>
        <p className="text-xs text-[var(--grey)] mb-10">Reference: <span className="font-mono">{id}</span></p>
        <p className="text-sm text-[var(--grey)] mb-10">Please send the email to confirm your request. We'll contact you shortly to finalize your order.</p>
        <Link to="/shop" className="link-lux text-xs tracking-[0.25em] uppercase">Continue Shopping</Link>
      </div>
    </main>
  );
};

export default OrderConfirmation;
